export var PersistTypes;
(function (PersistTypes) {
    /**
    Can have a different value for each language (dataSchema) - default
    */
    PersistTypes["multiLingualVariable"] = "multiLangVar";
    /**
    Can have a different value for mobile or desktop breakpoints in editor classic (propertiesSchema)
    **/
    PersistTypes["staticVariable"] = "staticVar";
    /**
    Will be defined as a CSS variable that can have a different value per breakpoint in responsive editor (styleNamespace)
    **/
    PersistTypes["cssVariable"] = "cssVar";
})(PersistTypes || (PersistTypes = {}));
//# sourceMappingURL=panels.js.map